import { ListItemText } from "@mui/material";
import { CoreButton, CoreMenuItem, CoreSearchField } from "../../../core";
import EditQuizFilter, { EDIT_QUIZ_FILTER_TYPE, EditQuizFilterType } from "../../components/EditQuizFilter";
import styles from "./GroupedList.module.css";
import { SelectAllContainer } from "./OptionListsComponents";

type GroupedListToolbarProps = {
	slotProps: {
		textfield: {
			placeholder: string;
			controlId: string;
			totalResults: number;
			setSearchText: (val: string) => void;
			searchText: string;
		};
		filter: {
			activeStatus: EditQuizFilterType;
			setActiveStatus: (status: EditQuizFilterType) => void;
			renderFilterLabel: (val: EditQuizFilterType) => React.ReactNode;
			ariaLabel: string;
		};
	};
};

export function GroupedListToolbar({ slotProps }: GroupedListToolbarProps) {
	const { filter, textfield } = slotProps;
	const { controlId, placeholder, searchText, setSearchText, totalResults } = textfield;
	const { activeStatus, renderFilterLabel, setActiveStatus, ariaLabel } = filter;

	return (
		<div className={styles.filterRow}>
			<CoreSearchField
				label={placeholder}
				ariaControls={controlId}
				totalResults={totalResults}
				onSearch={(value) => setSearchText(value)}
				value={searchText}
				noForm
			/>
			<EditQuizFilter<EditQuizFilterType>
				ariaLabel={ariaLabel}
				value={activeStatus}
				onChange={(value) => setActiveStatus(value)}
				renderValue={(value) => renderFilterLabel(value)}
			>
				{EDIT_QUIZ_FILTER_TYPE.map((type) => {
					return (
						<CoreMenuItem key={type} value={type}>
							<ListItemText primary={renderFilterLabel(type)} />
						</CoreMenuItem>
					);
				})}
			</EditQuizFilter>
		</div>
	);
}

type GroupedListSelectAllRowProps = {
	checked: boolean;
	onChange: () => void;
	badgeText: string | undefined;
	onClick: () => void;
	buttonText: string;
};

export function GroupedListSelectAllRow({
	badgeText,
	checked,
	onChange,
	onClick,
	buttonText,
}: GroupedListSelectAllRowProps) {
	return (
		<SelectAllContainer
			checked={checked}
			onChange={onChange}
			slotProps={{
				...(badgeText && {
					badge: {
						text: badgeText,
					},
				}),
			}}
			className={styles.groupedSelectAll}
		>
			{/**Shouldn't hardcode aria-haspopup... */}
			<CoreButton onClick={onClick} aria-haspopup="dialog">
				{buttonText}
			</CoreButton>
		</SelectAllContainer>
	);
}
